<template>
  <v-card>
    <v-card-subtitle>请在3分钟内完成密码重设</v-card-subtitle>
    <v-card-text>
      <v-form ref="stepForm">
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="pwd1" :rules="[rules.required,rules.password]" dense type="password" autocomplete="off" outlined class="rounded-0" label="请输入新密码"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field v-model="pwd2" :rules="[rules.required,rules.password,rules.same]" dense type="password" autocomplete="off" outlined class="rounded-0" label="请再次输入"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn color="primary" @click="onNext">提交
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn class="ml-2" text color="primary" @click="onBack">返回</v-btn>
    </v-card-actions>
  </v-card>

</template>
<script>
import { required, password } from '@/plugins/rules';
import md5 from 'md5';

export default {
  data () {
    return {
      pwd1: '',
      pwd2: '',
      rules: {
        required: required(), password: password(),
        same: (v) => {
          return (v && v == this.pwd1) || '两次密码输入不一致';
        }
      }
    }
  },
  methods: {
    onNext () {
      if (!this.$refs.stepForm.validate()) return;
      this.$emit('change', md5(this.pwd1));
    },
    onBack () {
      this.$emit('back');
    },
  }
}
</script>